const STYLE = {
  hero: { h: 22, bg: "bg-slate-700", label: "Hero" }, media: { h: 12, bg: "bg-slate-400", label: "Video" }, how_to: { h: 9, bg: "bg-sky-300", label: "Come" },
  stores: { h: 6, bg: "bg-slate-300", label: "Sedi" }, prizes: { h: 12, bg: "bg-amber-300", label: "Premi" }, share: { h: 7, bg: "bg-emerald-300", label: "Invita" },
  rules: { h: 6, bg: "bg-slate-300", label: "Regol." }, text_image: { h: 11, bg: "bg-indigo-300", label: "Testo+img" }, video: { h: 12, bg: "bg-rose-300", label: "Video" },
  faq: { h: 10, bg: "bg-violet-300", label: "FAQ" }, countdown: { h: 7, bg: "bg-orange-300", label: "Timer" }, gallery: { h: 10, bg: "bg-pink-300", label: "Galleria" }, button: { h: 5, bg: "bg-amber-400", label: "CTA" },
};

export default function TemplateThumb({ blocks }) {
  return (
    <div className="w-full rounded-md border border-border bg-white p-1 flex flex-col gap-[2px] shrink-0 overflow-hidden" style={{ height: 96 }} aria-hidden data-testid="template-thumb">
      {blocks.map((b, i) => {
        const s = STYLE[b.type] || STYLE.rules;
        return <div key={`${b.type}-${i}`} className={`${s.bg} rounded-[2px] flex items-center justify-center text-[6px] leading-none font-semibold text-slate-700/80 ${b.type === "hero" ? "text-white/90" : ""}`} style={{ height: s.h, minHeight: 4 }} title={s.label}>{s.h >= 9 ? s.label : ""}</div>;
      })}
    </div>
  );
}
